export const MAX_SAFEST_INTEGER = 2147483647;
